import PayByLink from './PayByLink'

export * from './PayByLink'
export * from './components'
export default PayByLink
